'use strict';

angular.module('app')
    .controller('DiveSiteCtrl', function($scope, $rootScope, $routeParams, $timeout, $location, DiveSite, Destinations, cartService, Search, leafletData, item, config, SeoService, Wishlist, GTM, localStorageService, RecentlyViewed) {

        var map,
            vm = this;

        vm.searchAPI = Search;

        if (item.status === 404) {
            $rootScope.notFound = true;

        } else {
            vm.info = item;
            vm.dueNow = cartService.getDueNowValue();

            if (vm.info.productsCount > 0) {
                vm.haveProducts = true;
            }

            vm.carts = (window.localStorage['productInCart']) ? JSON.parse(window.localStorage['productInCart']) : [];
        }


        if (vm.info) {
            RecentlyViewed.add({
                item_type: 'DiveSite',
                item_slug: item.slug
            });

            var title = vm.info.title + ' - Dive Site in ' + vm.info.area + ', ' + vm.info.country + ' - PADI Travel',
                description = 'Explore the dive site ' + vm.info.title + ' in ' + vm.info.area + ', ' + vm.info.country + '. Reviews, ratings, photos, itineraries and schedules. Easily book your next dive safari online.';

            SeoService.generateMetaTags(title, description, vm.info.thumbnails.DOSliderDesktop);

            $scope.monthes = config.months;

            $scope.center = {
                lat: vm.info.latitude,
                lng: vm.info.longitude,
                zoom: 14
            };

            Destinations.getMarineLife('area', vm.info.areaSlug).then(function(data) {
                $scope.marineLife = data;
            });

            leafletData.getMap('search-map').then(function(m) {
                map = m;

                DiveSite.getShops(vm.info, $scope).then(function(data) {
                    $scope.markers = data;
                    vm.locationMarkers = data;


                    $scope._infowindow = DiveSite.generatePin(vm.info, $scope).info;

                    $timeout(function() {
                        var bounds = map.getBounds();
                        vm.filter = {
                            kind: 20,
                            center: $scope.center.lat + ',' + $scope.center.lng
                        };

                        vm.filter.leftBound = bounds._southWest.lat + ',' + bounds._southWest.lng;
                        vm.filter.rightBound = bounds._northEast.lat + ',' + bounds._northEast.lng;

                        Search.getDiveSites($scope, vm.filter, true).then(function(data) {
                            vm.diveResorts = data.markers;
                        });
                    }, 400);
                });
            });


            vm.cartTotalPrice = cartService.getTotalPrice;

            // delete product from cart
            vm.deleteFromCart = function(index) {
                cartService.deleteFromCart(index, function(data) {
                    vm.carts = data;
                    vm.cartTotalPrice();
                });
            };

            vm.checkout = cartService.checkout;

            DiveSite.getPhotos().then(function(data) {
                vm.photos = data;

                vm.allPhotos = data.allPhotos;
                $scope.slidersImagesActive = data.allPhotos;
            });

            $scope.$on('leafletDirectiveMarker.search-map.click', function(e, args) {
                $scope._infowindow = args.model.info;
            });


            $scope.resize = function() {
                if (map) {
                    map.invalidateSize();
                }
            };

            vm.graphs = {};


            vm.units = {
                visibility: 'm',
                underWaterTemp: 'C'
            };

            vm.showOnMap = function() {
                vm.showDS = !vm.showDS;

                if (vm.showDS) {
                    $scope.markers = _.clone($scope.markers.concat(vm.diveResorts));
                } else {
                    $scope.markers = vm.locationMarkers;
                }
            };

            var underWaterTemp,
                visibility,
                logsPerMonth,
                visibilityYearlyAvg,
                underWaterTempAvg;


            DiveSite.statistic().then(function(data) {
                vm.graphs = data;

                underWaterTemp = _.clone(vm.graphs.underWaterTemp);
                visibility = _.clone(vm.graphs.visibility);
                logsPerMonth = _.clone(vm.graphs.logsPerMonth);
                visibilityYearlyAvg = _.clone(vm.graphs.visibilityYearlyAvg);
                underWaterTempAvg = _.clone(vm.graphs.underWaterTempAvg);

                vm.units = {
                    visibility: $rootScope.distance == 0 ? 'm' : 'feet',
                    underWaterTemp: $rootScope.temperature == 0 ? 'C' : 'F'
                };

            });

            $scope.$watch(function() {
                return vm.units;
            }, function(newVal) {
                recalculateGraphs();
            }, true);


            vm.allReviews = [];

            DiveSite.reviews().then(function(rating) {
                vm.reviews = rating;

                _.map(rating.data.results, function(val) {
                    vm.allReviews.push(val);
                });
            });


            /*
             Add review modal window step. Need to use $scope, because we can't work with vm in directive.
             */
            $scope.step = 1;

            vm.addReview = {};

            vm.submitReview = function(form) {
                form.$submitted = true;

                if (vm.addReview.agreement) {
                    form.loading = true;
                    if ($rootScope.user) {
                        DiveSite.addReview(vm.addReview).then(function(res) {
                            form.$submitted = false;

                            if (vm.reviews.data.results) {
                                vm.reviews.data.results.unshift(res);
                            } else {
                                vm.reviews.data.results = res;
                            }

                            vm.info.rating = res.diveSiteRating;
                            $scope._infowindow.rating = res.diveSiteRating;
                            vm.reviews.numberOfReviews++;
                            vm.reviews.reviewsPosted = true;

                            form.loading = false;

                            jQuery.fancybox.close();
                        }).catch(function() {
                            form.loading = false;
                            $rootScope.showNotify('Something went wrong! Please try again later.');
                        });
                    } else {
                        $rootScope.review = _.clone(vm.addReview);
                        $rootScope.review.diveSiteSlug = $routeParams.slug;
                        $location.path('/login/');
                        jQuery.fancybox.close();
                    }
                }
            };

            $scope.setValue = function(params) {
                vm.addReview[params.model] = params.rating;
            };

            vm.getMoreReviews = function() {
                DiveSite.reviews(vm.reviews.data.next).then(function(rating) {
                    vm.reviews = rating;

                    _.map(rating.data.results, function(val) {
                        vm.allReviews.push(val);
                    });

                    vm.reviews.data.results = vm.allReviews;
                });
            };

            vm.infoWindowLink = function(result) {
                return $location.path(Search.generateUrl(result)).hash('');
            };

            vm.triggerWishlist = function(type) {
                if (!$rootScope.user) {
                    $rootScope.showNotify('You need to create an account in order to save items to your wishlist');
                }
                var data = {
                    item_type: 'DiveSite',
                    item_slug: $routeParams.slug
                };

                if (type == 'delete') {
                    data = vm.info.isWishlist;
                }

                Wishlist[type](data).then(function(data) {
                    if (type == 'delete') {
                        vm.info.isWishlist = false;
                    } else {
                        vm.info.isWishlist = data.item.id;
                    }
                });
            };


            function recalculateGraphs() {
                if (vm.units.underWaterTemp == 'F') {
                    var newVal = [],
                        avg = [];
                    _.each(underWaterTemp, function(val) {
                        if (val) {
                            val = Math.round(((val * 9 / 5) + 32) * 100) / 100;
                        }

                        newVal.push(val);
                    });

                    _.each(underWaterTempAvg, function(val) {
                        if (val) {
                            val = Math.round(((val * 9 / 5) + 32) * 100) / 100;
                        }

                        avg.push(val);
                    });

                    vm.graphs.underWaterTemp = newVal;
                    vm.graphs.underWaterTempAvg = avg;
                } else {
                    vm.graphs.underWaterTempAvg = underWaterTempAvg;
                    vm.graphs.underWaterTemp = underWaterTemp;
                }

                if (vm.units.visibility == 'feet') {
                    var newVal = [],
                        avgVal = [];

                    _.each(visibility, function(val) {
                        if (val) {
                            val = Math.round((val * 3.28) * 100) / 100;
                        }

                        newVal.push(val);
                    });

                    _.each(visibilityYearlyAvg, function(val) {
                        if (val) {
                            val = Math.round((val * 3.28) * 100) / 100;
                        }

                        avgVal.push(val);
                    })

                    vm.graphs.visibility = newVal;
                    vm.graphs.visibilityYearlyAvg = avgVal;
                } else {
                    vm.graphs.visibility = visibility;
                    vm.graphs.visibilityYearlyAvg = visibilityYearlyAvg;
                }
            }

            angular.extend($scope, {
                defaults: {
                    scrollWheelZoom: false,
                    zoomControlPosition: 'bottomleft'
                },
                layers: {
                    baselayers: {
                        mapbox_light: {
                            name: 'Mapbox Diviac',
                            url: '//api.tiles.mapbox.com/v4/{mapid}/{z}/{x}/{y}.png?access_token={apikey}',
                            type: 'xyz',
                            layerOptions: {
                                apikey: 'pk.eyJ1IjoiYW5pb3Jrb3dhIiwiYSI6ImViNmUyOGFkMzExZThkMjIzNTdhMWVlYThjYmZmOGNjIn0.VpyrpaL2NpwHDCQ83qt93w#8/12.214/-84.963',
                                mapid: 'aniorkowa.mpe29hcd',
                                showOnSelector: false
                            }
                        }
                    }
                }
            });
        }

        // save date to session storage
        $scope.saveDate = function(date) {
            if (date[0] && date[1]) {
                // date[0] = moment(date[0]).format('YYYY-MM-DD');
                // date[1] = moment(date[1]).format('YYYY-MM-DD');

                $scope.$apply(function() {
                    // vm.from = date[0];
                    // vm.to = date[1];
                    vm.from = moment(date[0]).format('L');
                    vm.to = moment(date[1]).format('L');

                    vm.fromFullDate = date[0];
                    vm.toFullDate = date[1];

                    if (vm.enquire) {
                        vm.enquire.firstDay = date[0];
                        vm.enquire.lastDay = date[1];
                    }
                });

                localStorageService.set('date', date);
                vm.sidebarFilterDate = {
                    month: moment(date[0]).format("MMMM"),
                    startDate: moment(date[0]).format('YYYY-MM-DD'),
                    endDate: moment(date[1]).format('YYYY-MM-DD'),
                    year: (new Date(date[0])).getFullYear()
                };

                vm.haveDate = vm.sidebarFilterDate.startDate;

            } else {
                localStorageService.set('date', []);
            }
        };

        // sidebar filter
        vm.showPrices = function() {
            if (vm.from && vm.to) {
                vm.filterDate = vm.sidebarFilterDate;

                vm.showDetail = false;

                if (vm.selectedGuests) {
                    localStorageService.set('guests', vm.selectedGuests);
                }
            }
        };

        vm.guests = config.guests;

        // set session date
        if (localStorageService.get('date')) {
            // vm.from = localStorageService.get('date')[0];
            // vm.to = localStorageService.get('date')[1];
            vm.from = moment(localStorageService.get('date')[0]).format('L');
            vm.to = localStorageService.get('date')[1] ? moment(localStorageService.get('date')[1]).format('L') : '';

            vm.fromFullDate = localStorageService.get('date')[0];
            vm.toFullDate = localStorageService.get('date')[1] ? localStorageService.get('date')[1] : '';

            vm.sidebarFilterDate = {
                month: moment(localStorageService.get('date')[0]).format("MMMM"),
                startDate: moment(localStorageService.get('date')[0]).format('YYYY-MM-DD'),
                endDate: moment(localStorageService.get('date')[0]).format('YYYY-MM-DD'),
                year: (new Date(localStorageService.get('date')[0])).getFullYear()
            };

            vm.filterDate = vm.sidebarFilterDate;
            vm.selectedGuests = localStorageService.get('guests') || vm.guests[0];
        } else {
            vm.showDetail = true;
        }


        return vm;

    })